import { createStore, combineReducers, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import { Router, Route, Redirect, IndexRoute, IndexRedirect, Link, useRouterHistory } from 'react-router'
import { createHashHistory } from 'history'
import configureStore from './store/configureStore'
import rootReducer from './reducers/index'
import 'whatwg-fetch';

import './index.css'
import Home from './components/Home.js'
import Apps from './components/Apps.js'
import App from './components/App.js'
import Search from './components/Search.js'
import User from './components/User.js'
import AppApply from './components/AppApply.js'

import Register from './components/Register.js'

import Customer from './components/app/appApply/Customer.js'

const store = configureStore(
	rootReducer,
	applyMiddleware(
		thunkMiddleware
	)
);

//console.log(window.debug);
window.debug &&　store.subscribe(() =>
  	console.log("redux state",store.getState())
);

const history = useRouterHistory(createHashHistory)();

class Root extends React.Component {
    render() {
		return (
            <Provider store={store}>
				<Router history={history}>
					<Redirect from="/" to="apps" />
					<Route path="/" breadcrumbName="首页" component={Home}>
						<Route name="apps" path="apps" component={Apps} />
						<Route name="app" path="app/:id" component={App} />
						<Route name="search" path="search" component={Search} />
						<Route name="user" path="user" component={User} />
						<Route name="apply" path="apply/:id" component={AppApply} />
						<Route name="customer" path="customer/:id" component={Customer} />
						<Route name="register" path="register" component={Register} />
					</Route>
				</Router>
			</Provider>
        )
    }
}
setTimeout(function() {
    try {
    	
        let params = document.getElementById('params').innerHTML;
        //console.log('----params',params);
        
        if(!!params){
	        localStorage.setItem("me",params);
        }
		ReactDOM.render(<Root />, document.getElementById('container'));
        
        //再次获取信息
        let hash = window.location.hash;
		let key = !!hash && hash.indexOf('key=') > 0 ? hash.split('&')[0].split('/')[1].substring(4) : '';
		if(!!key){
			const server = window.server || "";
			fetch(server + '/newlogin' + key,{
				method: 'GET',
			}).then(res => {
				return res.json();
			}).then(data => {
				if(data.status){
					!!data.params && localStorage.setItem("me",JSON.stringify(data.params));
					history.push(!!data.path ? data.path : '/');
				}
			}).catch(ex=> {
				console.log('重新获取登陆信息失败:', ex)
			});
		}
    } catch(e) {
        console.log("render出错：" + e);
    }
}, window.debug ? 100 : 0);




// WEBPACK FOOTER //
// ./project/index.js